module.exports = __webpack_public_path__ + "img/map.86f4a83c.webp";